import React,{useState,useEffect,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'


/*----function with pagination----*/

const pageSize = 5;

const Corpaddusermain= ()=>  {


  const[pop,setpop] = useState(false);

  // GET request using fetch()

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const [allusers,setAllusers]= useState([])

  const [paginatedPosts, setpaginatedPosts] = useState();
  //const [currentPage, setcurrentPage] = useState(1);


  useEffect(()=>{
    Getusers();
    getCorpRoles();
  },[])


  function Getusers(){

    console.log("Token",token)

    fetch(`${BASE_URL}/Kdpcorp/GetCorpUsers`, {
     
    method:'GET',

      headers : {

        "Content-type": "application/json",

        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },

      //body:JSON.stringify(data)

    }).then(response => response.json())
    .then(data => {
      console.log("Data",data)
      setAllusers(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      localStorage.setItem("CorpUsers",JSON.stringify(data))
    });

    console.log("check",allusers)
  }

  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
  // // if (pageCount === 1)
  // // return null;
  
  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo - 1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setpaginatedPosts(paginatedPost)
  // }

 

/*---fetch add user----*/

function fetchCorpdata()

  {



    let data = {

      username:document.getElementById('name').value,

      email:document.getElementById('mail').value,

      password:document.getElementById('Corp-password').value,

      role:document.getElementById('role').value,
      roleid:'02',
      ventureid:'05',
      active:1,
      deleteStatus:0,
      assignStatus:1,
      ventureName:'Kdp Corp'

    }

    axios({



        method:"POST",

        url:`${BASE_URL}/Authenticate/Register`,

        data,

        headers: {

          "Content-Type" : "application/json"

        }
 })

    .then((response) =>{

      console.log(response.data);


    if(response.data.status === "Success"){

      alert("Registered Successfully !")

          // position: "top-center",

          // autoClose: 3200,

          // hideProgressBar: false,

          // closeOnClick: true,

          // pauseOnHover: true,

          // draggable: true,

          // progress: undefined,

          // className: 'toast-message'

          // });

         
      setTimeout(() => {
        Corpcloseform();
        Getusers();
      }, 500);

 }

       else if(response.data.status === "UserError"){
       
        // alert("User creation failed !") {

        //   position: "top-center",

        //   autoClose: 3200,

        //   hideProgressBar: false,

        //   closeOnClick: true,

        //   pauseOnHover: true,

        //   draggable: true,

        //   progress: undefined,

        //   className: 'toast-message'

        //   });

          }


          else if(response.data.status === "EmailError"){

            alert("Email Already Exist  !")

            // toast.error("Email Already Exist  !", {
    
            //   position: "top-center",
    
            //   autoClose: 3200,
    
            //   hideProgressBar: false,
    
            //   closeOnClick: true,
    
            //   pauseOnHover: true,
    
            //   draggable: true,
    
            //   progress: undefined,
    
            //   className: 'toast-message'
    
            //   });
    
               }

   

      else if(response.data.status === "Error"){

        alert("User creation failed !")
      // toast.error("User creation failed !", {

      //     position: "top-center",

      //     autoClose: 3200,

      //     hideProgressBar: false,

      //     closeOnClick: true,

      //     pauseOnHover: true,

      //     draggable: true,

      //     progress: undefined,

      //     className: 'toast-message'

      //     });

       }
 })

.catch(error => {
console.log(error);
})

}



/*----function with validation----*/

function handleSubmit(event){
  event.preventDefault()


  var name = document.getElementById("name").value;
  var mail = document.getElementById("mail").value;
  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var password = document.getElementById("Corp-password").value;
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
  var role = document.getElementById("role").value;

  if(!name){
        
    document.getElementById("nameErr").innerHTML="Username Required";
  
   
  }
  else if(name.length<3)
  {
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
    
  }
  else{
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML=" ";
  }

  if(!mail){

    document.getElementById("mailErr").innerHTML="Mail Required ";    
  }
  else if (email1.test(document.getElementById("mail").value)===false){

    document.getElementById("mailErrA").innerHTML="Not Valid Email";
    document.getElementById("mailErr").innerHTML=" ";  
 }
  else{

    document.getElementById("mailErr").innerHTML="  ";  
    document.getElementById("mailErrA").innerHTML="  ";  

  }
  if(!password){
  
    document.getElementById("passErr").innerHTML="Password Required ";    
    document.getElementById("passErrA").innerHTML="  ";  
  }
  else if (password1.test(document.getElementById("Corp-password").value)===false){

    document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById("passErr").innerHTML=" ";  
 }
  else{

    document.getElementById("passErr").innerHTML="  ";  
    document.getElementById("passErrA").innerHTML="  ";  

  }

  if(!role){

    document.getElementById("roleErr").innerHTML="Role Required ";
  }
  else{

    document.getElementById("roleErr").innerHTML=" ";
  }

  if((name.length>=3)&&(email1.test(document.getElementById("mail").value)===true)&&(password1.test(document.getElementById("Corp-password").value)===true)&& role){
    fetchCorpdata();
  }

}

function handlechange(event){
  event.preventDefault()

  var name = document.getElementById("name").value;

  var mail = document.getElementById("mail").value;

  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  var password = document.getElementById("Corp-password").value;
  
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
 
  var role = document.getElementById("role").value;

  if(!name){
        
    document.getElementById("nameErr").innerHTML="Username Required";
    document.getElementById("nameErrA").innerHTML=" ";
   
  }
  else if(name.length<3)
  {
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
    
  }
  else{
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML=" ";
  }

  if(!mail){

    document.getElementById("mailErr").innerHTML="Mail Required ";
    document.getElementById("mailErrA").innerHTML="  ";      
  }
  else if (email1.test(document.getElementById("mail").value)===false){

    document.getElementById("mailErrA").innerHTML="Not Valid Email";
    document.getElementById("mailErr").innerHTML=" ";  
 }
  else{

    document.getElementById("mailErr").innerHTML="  ";  
    document.getElementById("mailErrA").innerHTML="  ";  

  }
  if(!password){
  
    document.getElementById("passErr").innerHTML="Password Required "; 
    document.getElementById("passErrA").innerHTML="  ";     

  }
  else if (password1.test(document.getElementById("Corp-password").value)===false){

    document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById("passErr").innerHTML=" ";  
 }
  else{

    document.getElementById("passErr").innerHTML="  ";  
    document.getElementById("passErrA").innerHTML="  ";  

  }
  
  if(!role){

    document.getElementById("roleErr").innerHTML="Role Required ";
  }
  else{

    document.getElementById("roleErr").innerHTML=" ";
  }
}




/*----Function open form----*/

function Corpopenform()

   {

      document.getElementById("modalRegisterForm").style.display = "block";

    }
    

/*----Function close form----*/

    function Corpcloseform()

    {

      window.location.reload();

       document.getElementById("modalRegisterForm").style.display = "none";

     }


       /*----Password function----*/

       function Corphide(){

        var x = document.getElementById("Corp-password");

        var eye = document.getElementById("Corp-eye");


        if(x.type === "password"){

          x.type = "text";

          eye.classList.remove("fa-eye-slash")

          eye.classList.add("fa-eye")
 }

        else{

          x.type = "password";

          eye.classList.remove("fa-eye")

          eye.classList.add("fa-eye-slash")

        }
 }

 
/*----del btn Onclick func----*/

function  CorpDeleteStatus(Id,userName){

  

      const body ={
        id: Id
      }
       console.log('check',body)
        axios({
       
        method:"POST",
       url:`${ BASE_URL}/Kdpcorp/CorpDeleteStatus`,
       data:body,
       headers: {
       "Content-Type" : "application/json",
       "Authorization": "Bearer " + `${token}`,

     
       }
      
        })
        .then((response) =>{
        console.log(response.data);
        alert("Deleted Successfully !")
        // toast.info(userName + " "+"Deleted Successfully !", {
        //  position: "top-center",
        //  autoClose: 3200,
        //  hideProgressBar: false,
        //  closeOnClick: true,
        //  pauseOnHover: true,
        //  draggable: true,
        //  progress: undefined,
        //  className: 'toast-message'
        //  });
         setTimeout(() => {
          closeForm();
           Getusers();
         }, 500);
       
     
        })
     
    }



    function ConfirmDelete(Id){


      document.getElementById("modalEditForm").style.display = "block";
      SelectParticular(Id)
    
    }
    
    function SelectParticular(Id){
      const body =
      {
        
       id:Id
      }
      console.log('body',body);
    
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Kdpcorp/GetCorpEditAddUsers`,
             data:body, 
             headers: {
                    "Content-type": "application/json",
                  "Authorization": "Bearer " +`${token}` 
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
       
            SetEditCorp(response.data);

            localStorage.setItem("EditData",JSON.stringify(response.data))
       
         })
         .catch(error => {
           console.log(error);
           
         })
    }
  
    



    /*----Get select to the particular Id----*/

    const [EditCorp ,SetEditCorp] =useState([]);
   
  
    
  


   function CorpEditfunction(Id){

    // const token = JSON.parse(localStorage.getItem('usertoken'));

    // document.getElementById("DisplayEditPop").style.display = "block";
  
    SelectParticular(Id)
    document.getElementById('CorpLoader').style.display = "none";
    setpop(true);

    setTimeout(() => {
      window.location.href="/?#/CorpEditPop"
     // window.location.reload()
      
    }, 1000);

   }

  //  ----------------------------------//

  /*---- Close Edit popup----*/

  function closeForm(){
    
    
    document.getElementById('modalEditForm').style.display="none";
    document.getElementById('form').reset();
   }

/*----EditSection----*/

const handleactive=()=>{
  setActive(1);
}

const[Active,setActive]=useState('0')


const handleInactive=()=>{
  setInActive(0);
}

const[InActive,setInActive]=useState('1')




     const[Roletable, setRoletable] =useState([])

  function getCorpRoles(){
      const token = JSON.parse(localStorage.getItem('usertoken'));
    
     
  
      fetch(`${BASE_URL}/Kdpcorp/GetCorpAddRole`, {
        method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": "Bearer " +`${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  
  
  })
  
  .then(response => response.json())
  
  
  .then(data => {
  console.log("CorpRole",data)
  setRoletable(data)
  
  });
  }
  
  // --------------------//
    
  const LEFT_PAGE = "LEFT";
  const RIGHT_PAGE = "RIGHT";
  const range = (from, to, step = 1) => {
    let i = from;
    const range = [];
  
    while (i <= to) {
      range.push(i);
      i += step;
    }
  
    return range;
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  
  let data = localStorage.getItem("CorpUsers")
  let transdata =  JSON.parse(data);
 
  let NUM_OF_RECORDS = transdata.length;
  let LIMIT = 5;
  
  const onPageChanged = useCallback(
  
    (event, page) => {
      event.preventDefault();
      setCurrentPage(page);
    },
    [setCurrentPage]
    
  );
  
  
  const currentData = transdata.slice(
    (currentPage - 1) * LIMIT,
    (currentPage - 1) * LIMIT + LIMIT
  );
  
  const Paginations = (props) => {
    const {
      totalRecords,
      pageLimit,
      pageNeighbours,
      onPageChanged,
      currentPage
    } = props;
    const [totalPages, setTotalPages] = useState(0);
    useEffect(() => {
      setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [setTotalPages]);
  
    const fetchPageNumbers = () => {
      const totalNumbers = pageNeighbours * 1 + 0;
    
      const totalBlocks = totalNumbers + 2;
     
      if (totalPages > totalBlocks) {
        const startPage = Math.max(2, currentPage - pageNeighbours);
        const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
  
        let pages = range(startPage, endPage);
  
        const hasLeftSpill = startPage > 2;
        const hasRightSpill = totalPages - endPage > 1;
        const spillOffset = totalNumbers - (pages.length + 1);
  
        switch (true) {
          case hasLeftSpill && !hasRightSpill: {
            const extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE, ...extraPages, ...pages];
            break;
          }
          case hasLeftSpill && hasRightSpill:
          default: {
            pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
            break;
          }
        }
        return [1, ...pages, totalPages];
      }
      return range(1, totalPages);
    };
  
  
    const pages = fetchPageNumbers() || [];
    return (
      <nav aria-label="Countries Pagination">
        <ul className="pagination" id='Paro-pag'>
          {pages.map((page, index) => {
            if (page === LEFT_PAGE)
              return (
                <li key={index} className="Corppage-item">
                  <a
                    href="/"
                    className="page-link"
                    aria-label="Previous"
                    onClick={(e) => onPageChanged(e, pageNeighbours)}
                  >
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
              );
  
            if (page === RIGHT_PAGE)
              return (
                <li key={index} className="Corppage-item">
                  <a
                    className="page-link"
                    href="/"
                    aria-label="Next"
                    onClick={(e) => onPageChanged(e, pageNeighbours*2+1 )}
                  >
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              );
  
            return (
              <li
                key={index}
                className={`Corppage-item${currentPage === page ? " active" : ""}`}
              >
                <a
                  className="page-link"
                  href="/"
                  onClick={(e) => onPageChanged(e, page)}
                >
                  {page}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  };





 /*----Main Container----*/

  return (
    <>
    <div className='Corp-addmain'>

    

    <div className="Corp-addgrid-layout">
  <div className="Corp-addmain-top">
    <div className='Corp-addmain-back'>
    <Link to='/Kdp Corp '><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Add User</span>
    
    </div>
    </div>

    <div className='Corp-addmain-add'>
      <button className='Corp-add-user' onClick={Corpopenform}>  
      <i class="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add User</button>
    </div>


    <div className='Corp-addmain-add'>
     <Link to='/CorpAddRole'> <button className='Corp-add-user'>  
     Add Role</button></Link>
    </div>

    <div className="Corp-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document" id="Corpcenterform">
    <div className="modal-content">

      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
        <button type="button" className="close" onClick={Corpcloseform}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>


      <form  onSubmit={handleSubmit}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
         
          <input type="text" className="form-control validate"  placeholder='Username' onKeyUp={handlechange} id="name"/>
          <span id="nameErr" className='error'></span>
          <span id="nameErrA" className='error'></span>

        </div>
        <div className="md-form mb-5">
          
          <input type="email"  className="form-control validate" placeholder='Email'  onKeyUp={handlechange} id="mail" />
          <span id="mailErr" className='error'></span>
          <span id="mailErrA" className='error'></span>
        </div>

        <div className="md-form mb-5">
          <div style={{display:"flex"}}>
          <input type="password" className="form-control validate" placeholder='Password'  onKeyUp={handlechange} id="Corp-password"/>
          <span className='Corp-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={Corphide} id="Corp-eye"></i></span>
          </div>
          
         
          <span id="passErr" className='error'></span>
          <span id="passErrA" className='error'></span>
        </div>

        
        <div className="md-form mb-4">
        <select  name="role"  className="form-select"  onInputCapture={handlechange} id="role" >

         <option value="">Role</option>

        {/* <option value="02">Team mate</option> */}

        {Roletable.map((e)=>
            {
              return<option value={e.role}>{e.role}</option> })}
                         

        </select>    
        <span id="roleErr" className='error'></span>  
       
        </div>

      </div>
      
      <div className="modal-footer d-flex justify-content-center">
        <button className="Corp-adduser-button" >Submit</button>
      </div>

      </form>


    </div>
  </div>
</div>

<div id="CorpLoader">
<div className='Corp-table'>
<div class="Corp-table_responsive">

{
  !paginatedPosts ? ("No data found"):(
  <table> 
    <thead>
   <tr>
<th>Username</th>
<th>Email</th>
<th>Action</th>

</tr>
</thead>
<tbody>

  {/* mapping to adduser */}

{currentData.map((e,index) => {
      return<tr key={index}>

           <td>{e.userName}</td>
           <td>{e.email}</td>

           {/* <td> {e.active==1 ?<button id ='CorpActive-buttonA'onClick={()=>ActiveStatus(e.id,e.active)}>Active</button>:
              <button id ='CorpActive-buttonB'onClick={()=>ActiveStatus(e.id,e.active)}>InActive</button>}&nbsp;
                <button id ='CorpDelete-ButtonC' onClick={()=>CorpDeleteStatus(e.id,e.userName)}>Delete</button></td> */}
      <td style={{whiteSpace:"nowrap"}}>
               
               <span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>CorpEditfunction(e.id,e.active,e.userName)} id="CorpEdit-icon"></i></span>&nbsp;&nbsp;
               <span><i class="fa fa-trash" aria-hidden="true"onClick={()=>ConfirmDelete(e.id,e.userName)} id="CorpDelete-icon"></i></span>
             
             </td>
      
      </tr>
      })}
</tbody>

</table>
)}

<br></br>

{transdata.length<=5? null:<div>
  {

!paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

pageLimit={LIMIT}

pageNeighbours={2}

onPageChanged={onPageChanged}

currentPage={currentPage}

/>

)}
</div>
}

  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> */}
  
  </div>


    </div>

    </div>


    {/* EditPopup

<div className='Paropop-fade' id="DisplayEditPop">
{EditCorp.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT USER</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="EditParoform"onSubmit={()=>updateCorp(e.id,e.active)} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

        
          <input type="text" id="CorpEditName"  defaultValue={e.userName}/>
          <span id="EditErrA" className='error'></span>
        </div> 

        <div className="md-form mb-5">
        
         <input type="text" defaultValue={e.email} readOnly/>
        
        </div>

        <div className="md-form mb-5">
       
        {e.active==1 ? 
     
     <center>
     <input type="checkbox" id="Corpinactiveswitch"
                  class="InActivecheckbox" onChange={handleInactive} />
      <label for="Corpinactiveswitch" className="toggleinactive">
           

   <p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;InActive</p>


      </label>
   
      </center>:
          
    
     
          <center>
          <input type="checkbox" id="Corpactiveswitch"
                       className="Activecheckbox"  onChange={handleactive}/>
           <label for="Corpactiveswitch" className="toggleactive">
                
    
        <p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;InActive</p>
    
    
           </label>
        
           </center>
}
       
       </div>


      </div>

      <div className="modal-footer d-flex justify-content-center" id="Corp-Save-btn">
        <button className='Corp-adduser-button' type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>})} */}

{/* </div> */}

<div className="Paropop-fade" id="modalEditForm" tabindex="-1" role="dialog">
{EditCorp.map((e)=>{
   return<div className="modal-dialog" role="document"id="CorpcenterDelform" >
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">DELETE</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to delete?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <button className="Corp-logout-button" type='submit' onClick={()=>CorpDeleteStatus(e.id,e.userName)}>Confirm</button>
        <button className="Corp-logout-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
  })}
</div>


{pop? <div id="Loader">

{/* <CircleLoader color="grey" /> */}
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    </div>
       
    </>
  )
}

export default Corpaddusermain
